/**
 * Loading Skeleton Component
 *
 * Displays skeleton loading states for the return order modal
 * while data is being fetched.
 */

import {
  Box,
  Card,
  CardContent,
  Grid2,
  Skeleton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow
} from "@mui/material"
import Stack from "src/shared/components/stack"

/**
 * Loading skeleton component for return order modal
 */
export default function LoadingSkeleton() {
  return (
    <Stack gap={3}>
      {/* Summary Cards Skeleton */}
      <Grid2 container spacing={2}>
        <Grid2 size={{ xs: 12, md: 6 }}>
          <Card variant="outlined">
            <CardContent>
              <Skeleton variant="text" width={100} height={24} sx={{ mb: 2 }} />
              <Grid2 container spacing={2}>
                <Grid2 size={{ xs: 6 }}>
                  <Skeleton variant="text" width={80} height={20} />
                  <Skeleton variant="text" width={120} height={24} />
                </Grid2>
                <Grid2 size={{ xs: 6 }}>
                  <Skeleton variant="text" width={80} height={20} />
                  <Skeleton variant="text" width={120} height={24} />
                </Grid2>
                <Grid2 size={{ xs: 6 }}>
                  <Skeleton variant="text" width={80} height={20} />
                  <Skeleton variant="text" width={120} height={24} />
                </Grid2>
                <Grid2 size={{ xs: 6 }}>
                  <Skeleton variant="text" width={80} height={20} />
                  <Skeleton variant="rectangular" width={80} height={24} sx={{ borderRadius: 1 }} />
                </Grid2>
              </Grid2>
            </CardContent>
          </Card>
        </Grid2>

        <Grid2 size={{ xs: 12, md: 6 }}>
          <Card variant="outlined">
            <CardContent>
              <Skeleton variant="text" width={150} height={24} sx={{ mb: 2 }} />
              <Stack gap={2}>
                {[1, 2, 3].map((i) => (
                  <Stack key={i} variant="rowCenter" gap={2}>
                    <Skeleton variant="circular" width={32} height={32} />
                    <Box sx={{ flex: 1 }}>
                      <Skeleton variant="text" width={100} height={20} />
                      <Skeleton variant="text" width={150} height={16} />
                    </Box>
                  </Stack>
                ))}
              </Stack>
            </CardContent>
          </Card>
        </Grid2>
      </Grid2>

      {/* Items Table Skeleton */}
      <Card variant="outlined">
        <CardContent>
          <Stack variant="rowCenterSpaceBetween" mb={2}>
            <Skeleton variant="text" width={80} height={24} />
            <Stack variant="rowCenter" gap={1}>
              <Skeleton variant="rectangular" width={60} height={24} sx={{ borderRadius: 1 }} />
              <Skeleton variant="rectangular" width={80} height={24} sx={{ borderRadius: 1 }} />
            </Stack>
          </Stack>

          <TableContainer>
            <Table size="small">
              <TableHead>
                <TableRow>
                  <TableCell>
                    <Skeleton variant="text" width={80} />
                  </TableCell>
                  <TableCell align="right">
                    <Skeleton variant="text" width={80} />
                  </TableCell>
                  <TableCell align="right">
                    <Skeleton variant="text" width={40} />
                  </TableCell>
                  <TableCell align="right">
                    <Skeleton variant="text" width={80} />
                  </TableCell>
                  <TableCell align="right">
                    <Skeleton variant="text" width={80} />
                  </TableCell>
                  <TableCell align="right">
                    <Skeleton variant="text" width={60} />
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {[1, 2].map((i) => (
                  <TableRow key={i}>
                    <TableCell>
                      <Stack gap={1}>
                        <Skeleton variant="text" width={150} />
                        <Skeleton variant="text" width={200} />
                      </Stack>
                    </TableCell>
                    <TableCell align="right">
                      <Skeleton variant="text" width={60} />
                    </TableCell>
                    <TableCell align="right">
                      <Skeleton variant="text" width={30} />
                    </TableCell>
                    <TableCell align="right">
                      <Skeleton variant="text" width={60} />
                    </TableCell>
                    <TableCell align="right">
                      <Skeleton variant="text" width={60} />
                    </TableCell>
                    <TableCell align="right">
                      <Skeleton variant="text" width={60} />
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </CardContent>
      </Card>
    </Stack>
  )
}
